(() => {
  const filters = document.querySelector('[data-lb-filters]');
  if (filters) {
    filters.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-filter]');
      if (!button) return;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      document.querySelectorAll('[data-category]').forEach(card => {
        card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
      });
    });
  }
  const builder = document.querySelector('[data-lb-builder]');
  if (builder) {
    builder.hidden = false;
    builder.addEventListener('change', () => {
      const chosen = [...builder.querySelectorAll('input:checked')].map(input => input.value);
      const link = builder.querySelector('a');
      const target = new URL(link.href);
      target.searchParams.set('categories', chosen.join(','));
      link.href = target.href;
    });
  }
  const form = document.getElementById('LotusBridgeEnquiry');
  if (form) {
    const params = new URLSearchParams(location.search);
    ['intent', 'category'].forEach(key => {
      const field = document.getElementById('LB-' + key);
      const value = params.get(key);
      if (value && [...field.options].some(option => option.value === value)) field.value = value;
    });
    const body = document.getElementById('LB-body');
    const categories = (params.get('categories') || '').split(',').filter(Boolean);
    const choices = [...document.getElementById('LB-category').options];
    const labels = categories.map(value => choices.find(option => option.value === value)?.textContent).filter(Boolean);
    const lines = [];
    if (labels.length) lines.push('Categories to discuss: ' + labels.join(', '));
    const briefs = {retail:'Retail shelf edit',temple:'Temple & practice brief',brass:'Brass statue enquiry'};
    if (briefs[params.get('brief')]) lines.push('Starting brief: ' + briefs[params.get('brief')]);
    const references = {holder:'Lotus incense holder',box:'Carved incense box',pendant:'Guanyin pendant'};
    if (references[params.get('reference')]) lines.push('Visual reference: ' + references[params.get('reference')]);
    if (params.get('product')) lines.push('Product enquiry: ' + params.get('product').slice(0, 250));
    if (!body.value.trim() && lines.length) body.value = lines.join('\n') + '\n\n';
    const feedback = form.querySelector('[role="status"], [role="alert"]');
    if (feedback) feedback.focus();
  }
  document.querySelectorAll('.lb-mobile-menu nav a').forEach(link => link.addEventListener('click', () => link.closest('details').removeAttribute('open')));
})();

(() => {
  const recoverPhoto = photo => {
    if (!(photo instanceof HTMLImageElement) || !photo.dataset.lbFallback || photo.dataset.lbRecovered === 'true') return;
    photo.dataset.lbRecovered = 'true';
    const picture = photo.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(source => source.removeAttribute('srcset'));
    photo.removeAttribute('srcset');
    photo.src = photo.dataset.lbFallback;
  };
  document.addEventListener('error', event => recoverPhoto(event.target), true);
  document.querySelectorAll('img[data-lb-fallback]').forEach(photo => {
    if (photo.complete && photo.naturalWidth === 0) recoverPhoto(photo);
  });
})();
